import React, { useEffect } from 'react';
import { useLanguage } from '../context/LanguageContext';
import { Send } from 'lucide-react';

const HUBSPOT_SCRIPT_SRC = 'https://js.hsforms.net/forms/embed/51298844.js';

export const ContactForm = () => {
  const { t, language } = useLanguage();
  const es = language === 'es';

  useEffect(() => {
    const existingScript = document.querySelector(`script[src="${HUBSPOT_SCRIPT_SRC}"]`);
    if (existingScript) return;

    const script = document.createElement('script');
    script.src = HUBSPOT_SCRIPT_SRC;
    script.defer = true;
    document.body.appendChild(script);

    return () => {
      const scriptToRemove = document.querySelector(`script[src="${HUBSPOT_SCRIPT_SRC}"]`);
      if (scriptToRemove) scriptToRemove.remove();
    };
  }, []);

  return (
    <section
      id="contact"
      data-testid="contact-section"
      className="bg-[#FAFAF7] py-16 md:py-[60px]"
    >
      <div className="max-w-3xl mx-auto px-6 md:px-12">
        <div className="text-center mb-12">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-[#0A2235] text-[#2BBFBF] rounded-[20px] mb-6">
            <Send className="w-8 h-8" />
          </div>
          <h2
            className="font-playfair text-3xl sm:text-4xl lg:text-5xl text-[#0A2235] mb-4 tracking-tight"
            data-testid="contact-section-title"
          >
            {es ? 'Agenda tu consulta sin costo' : 'Schedule your free consultation'}
          </h2>
          <p className="font-inter text-[#5F5E5A] text-base sm:text-lg font-light">
            {es ? 'Te respondemos en menos de 2 horas en días hábiles.' : 'We respond in less than 2 hours on business days.'}
          </p>
        </div>

        {/* HubSpot Form Container */}
        <div className="bg-white p-8 md:p-12 shadow-sm rounded-[20px]">
          <div 
            className="hs-form-frame" 
            data-region="na1" 
            data-form-id="4573ff37-66e2-46a1-b3c2-8567cacf38c5" 
            data-portal-id="51298844"
            data-testid="hubspot-form"
          />
        </div>
      </div>
    </section>
  );
};
